import React from 'react';
import { required, SelectInput, SimpleForm, NumberInput, Edit, Create, BooleanInput, EditButton, Filter, List
	, Datagrid, TextField, TextInput, NumberField } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';

const ExperimentFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);

export const ExperimentList = (props) => (
    <List {...props} filters={<ExperimentFilter />} perPage={25} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="code" label="ID" />
						<NumberField source="pace" label="Pace" />
            <TextField source="name" label="Name" />
            <EditButton variant="contained" color="primary" />
        </Datagrid>
    </List>
);

const ExperimentTitle = ({ record }) => {
    // return <span>Experiment {record ? `"${record.name}"` : ''} {record && record.active ? 'ACTIVE' : 'INACTIVE'}</span>;
		return <span>Experiment {record ? `"${record.name}"` : ''}</span>;
};

export const ExperimentEdit = (props) => (
    <Edit title={<ExperimentTitle />} {...props}>
    	<SimpleForm>
	        {/* <BooleanInput source="active" label="Active" defaultValue={true} validate={required()}/> */}
				<BooleanInput source="active" label="Active" defaultValue={true} style={{display: 'none'}} />
	      <TextInput source="name" label="Experiment Name" style={{ width: '400px' }} validate={required()} />
				<NumberInput source="code" label="Experiment ID" validate={required()} />
			<SelectInput label="Experiment Pace" source="pace" 
			    validate={required()}
				allowEmpty 
				helperText="Experiment Pace."
				choices={[
				{ id: 0, name: '1%' },
				{ id: 5, name: '5%' },
				{ id: 10, name: '10%' },
				{ id: 15, name: '15%' },
				{ id: 20, name: '20%' },
				{ id: 25, name: '25%' },
				{ id: 50, name: '50%' },
				{ id: 75, name: '75%' },
				{ id: 80, name: '80%' },
				{ id: 90, name: '90%' },
				{ id: 100, name: '100%' },
			]} />
        </SimpleForm>
    </Edit>
);

export const ExperimentCreate = (props) => (
	 <Create title={<ExperimentTitle />} {...props}>
	 <SimpleForm>
	    {/* <BooleanInput source="active" label="Active" defaultValue={true} validate={required()}/> */}
			<BooleanInput source="active" label="Active" defaultValue={true} style={{display: 'none'}} />
			<TextInput source="name" label="Experiment Name" style={{ width: '400px' }} validate={required()} />
	  	<NumberInput source="code" label="Experiment ID" validate={required()} />
		  <SelectInput label="Experiment Pace" source="pace" 
		    validate={required()}
			allowEmpty 
			helperText="Experiment Pace."
			choices={[
				{ id: 0, name: '0%' },
			{ id: 1, name: '1%' },
			{ id: 5, name: '5%' },
			{ id: 10, name: '10%' },
			{ id: 15, name: '15%' },
			{ id: 20, name: '20%' },
			{ id: 25, name: '25%' },
			{ id: 50, name: '50%' },
			{ id: 75, name: '75%' },
			{ id: 80, name: '80%' },
			{ id: 90, name: '90%' },
			{ id: 100, name: '100%' },
		]} />
	 </SimpleForm>
	 </Create>
);